<div class="row justify-content-center w-100">
    @for(item of data; track item?.name) {
        <div class="col-md-4 p-2">
            <div class="card border-0 key-value-card text-center d-flex flex-column justify-content-center">
                <strong> {{ item.value }} </strong>
                <div> {{ item.display_name }} </div>
            </div>
        </div>
    }
</div>